/** @file Export dialog form state and its defaults (rig, 2048 pages, verify on; empty lists = everything). */

/** What the dialog edits; `fit` and the sprite fields apply to sprite sheets only. */
export interface ExportFormState {
  target: 'rig' | 'spritesheet';
  maxPage: 1024 | 2048 | 4096;
  scale: number;
  fit: boolean;
  padding: number;
  animations: string[];
  skins: string[];
  directions: string[];
  frameW: number;
  frameH: number;
  /** 0 = the document's fps. */
  fps: number;
  layout: 'grid' | 'packed';
  verify: boolean;
}

/** §5.4 defaults; verify is on because the report is the dialog's point (R-E7-07). */
export const DEFAULT_EXPORT_FORM: ExportFormState = {
  target: 'rig', maxPage: 2048, scale: 1, fit: true, padding: 2, animations: [], skins: [], directions: [],
  frameW: 256, frameH: 256, fps: 0, layout: 'grid', verify: true,
};
